import { FormInput } from '@unified-checkout/kit-components';

export function ExpiryDate(props: any) {
  const {
    customStyle,
    customInputStyle,
    formRegister,
    maxLength,
    disabled,
    error,
    className,
    placeholder
  } = props;

  return (
    <FormInput
      name={'expiry'}
      error={error}
      formRegister={formRegister}
      placeholder={placeholder || 'MM/YY'}
      maxLength={maxLength}
      customStyle={customStyle}
      className={className}
      inputMode="numeric"
      autoComplete="cc-exp"
      pattern={'d*'}
      disabled={disabled}
      customInputStyle={customInputStyle}
    />
  );
}
